import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { RoleForm } from "./RoleForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface IRoleEditProps {}

export const RoleEdit = (props: IRoleEditProps) => {
  const notify = useNotification(props, "editSuccess");
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      mutationMode="pessimistic"
      title="resources.admin-roles.title.edit">
      <RoleForm isEdit />
    </Edit>
  );
};
